module.exports = __webpack_public_path__ + "themes/custom/iidb/dist/img/logo-waw.d7a908a9.svg";